import axios from 'axios'
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export const getPublicCatalogLink = async (id) => {
    const response = await axios(
        `${CATALOGO_ENDPOINT}/${id}/public-link`
    )
    return response.data;
}
